import React from 'react';

import style from './style/scoreGradeBar.scss';
import classNames from 'classnames';
import { TOXICS_RISKS } from '../../constants';

/**
 * @param {Object} props - props object
 * @param {Object} [props.i18nParticipation] - i18n object
 * @param {number} props.score - score
 * @param {boolean} [props.hasLabels] - true if labels should be shown
 *
 * @returns {JSX.Element} - score grade bar
 */
export function ScoreGradeBar(props) {
    const {
        i18nParticipation,
        score,
        hasLabels
    } = props;

    return (
        <div className={style.scoreGradeContainer}>
            {TOXICS_RISKS.map((grade, index) => (
                <div key={index} className={style.scoreGrade}>
                    { hasLabels ? (
                        <div className={style.label}>
                            {i18nParticipation[grade]}
                        </div>
                    ) : null}
                    <div className={classNames(style.bar, { [style.fill]: index < score })} />
                </div>
            ))}
        </div>
    );
}

export default ScoreGradeBar;
